import React, {useState} from 'react'
import axios from 'axios';
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
// import { response } from 'express';
import {toast, ToastContainer} from 'react-toastify';


const Register = () => {
 
const [inputField, setInputField] = useState({tregoName:"", email:"", mobile:"", userName:"", password:"", profilePic:"../../assets/tregoimg-removebg.png"}); 
 const [loaderImage, setLoaderImage] = useState(false);

const handleOnChange =(event, name)=>{
   setInputField({...inputField, [name]:event.target.value})
}



// const uploadImage = async(event)=>{
//     setLoaderImage(true);
//   // console.log("Image Uploading");
//   const files = event.target.files;
//   const data = new FormData();
//   data.append('file', files[0]);

//   data.append('upload_preset', 'trego.in');
//   try{
//      const response = await axios.post("https://api.cloudinary.com/v1_1/dvawsdzao/image/upload", data);
//     //  console.log(response);
//      const imageUrl = response.data.url;
//   setLoaderImage(false);

//      setInputField({...inputField, ['profilePic']:imageUrl})
//   }catch(err){
//     // console.log(err)
//     setLoaderImage(false)
//   }

// }

  // ✅ FIXED IMAGE UPLOAD
 
  const uploadImage = async (event) => {
    setLoaderImage(true);

    const files = event.target.files;
    if (!files || files.length === 0) {
      setLoaderImage(false);
      return;
    }

    const data = new FormData();
    data.append('file', files[0]);
    data.append('upload_preset', 'trego.in');

    try {
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/dvawsdzao/image/upload",
        data,
        {
          withCredentials: false // 🔥 MOST IMPORTANT FIX
        }
      );

      const imageUrl = response.data.secure_url; // ✅ HTTPS URL

      setInputField((prev) => ({
        ...prev,
        profilePic: imageUrl
      }));

      setLoaderImage(false);
      // toast.success("Image uploaded successfully ✅");

    } catch (err) {
      setLoaderImage(false);
      console.log(err);
      toast.error("Image upload failed ❌");
    }
  };


const handleRegister = async()=>{
// await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/auth/register`, inputField).then((response)=>{
  await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/auth/register`, inputField, { withCredentials: true }).then((response)=>{
  const successMsg = response.data.message;
  toast.success(successMsg);

}).catch(err=>{
 const errorMassege = err.response.data.error;
 toast.error(errorMassege);
})
}

  return (
        <div className="about__info">
         <h4 className='loginh4'>REGISTER</h4>

              <div className="">
                <input className='loginInput' type="email" value={inputField.email} onChange={(event)=>{handleOnChange(event, "email")}}  required placeholder="Enter Email" />
              </div>
              <div className="">
                <input className='loginInput' type="number" value={inputField.mobile} onChange={(event)=>{handleOnChange(event, "mobile")}}  required placeholder="Enter Your Mobile Number" />
              </div>

               <div className="">
                <input className='loginInput' type="text"  value={inputField.userName} onChange={(event)=>{handleOnChange(event, "userName")}}  required placeholder="Enter UserName" />
              </div>

              <div className="">
                <input className='loginInput' type="password"  value={inputField.password} onChange={(event)=>{handleOnChange(event, "password")}} required placeholder="Enter Password" />
              </div>

              <div className="">
                <input className='loginInput' type="text"  value={inputField.tregoName} onChange={(event)=>{handleOnChange(event, "tregoName")}} required placeholder="Enter Your Business Name" />
              </div>

              {/* <div className="">
                <input onChange={(e)=>{uploadImage(e)}} className='loginInput' type="file"  required />
              </div> */}

           <div>
             <input
                onChange={uploadImage}
                className='loginInput'
                type="file"
               required
             />
           </div>


       <div>
        {/* {loaderImage && (
          <Stack className='imgLoader' sx={{ width: "100%", color: "grey.500" }} spacing={2}>
            <LinearProgress color="secondary" />
          </Stack>
        )} */}

    {loaderImage ? (
  <div className="loader"></div>     
) : (
         <img
          src={inputField.profilePic}
          className='registerimg'
          alt="profile"
        />    
)}

        {/* <img
          src={inputField.profilePic}
          className='registerimg'
          alt="profile"
        /> */}
      </div>    

     {/* <div className="">

{
   loaderImage && <Stack className='imgLoader' sx={{ width: "100%", color: "grey.500" }} spacing={2}>
          <LinearProgress color="secondary" />
        </Stack>}

              <img src={inputField.profilePic} className='registerimg' />
        
              </div> */}


       <div className="contact__button button"onClick={()=>handleRegister()}>REGISTER</div>

<ToastContainer/>
        </div>
  )
}

export default Register
